import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import Header from "./component/Common/Header/Header";
import LayoutHandler from "./component/LayoutHandler";
import LayoutWithoutHeaderFooter from "./component/LayoutWithOutHeaderFooter";
import LayoutMobileRedirection from "./component/LayoutMobileRedirection";
import ProtectedRoute from "./component/ProtectedRoute";
import "../src/assets/sass/style.scss";
import SelectRole from "./component/SelectRole/SelectRole";
import store from "./Redux/store";
import Footer from "./component/Common/Footer/Footer";
import { useEffect } from "react";
// App.js or layout componentimage.png/pro-plan
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import SignUpStepOne from "./component/Professional/SignUpStepOne/SignUpStepOne";
import SignUpStepTwo from "./component/Professional/SignUpStepTwo/SignUpStepTwo";
import SignUpStepThree from "./component/Professional/SignUpStepThree/SignUpStepThree";
import SignUpStepFour from "./component/Professional/SignUpStepFour/SignUpStepFour";
import Login from "./component/Client/Login/Login";
import Forgot from "./component/Client/Forgot/Forgot";
import SignUp from "./component/Client/SignUp/SignUp";
import SignUpStepOneClient from "./component/Client/SignUpStepOne/SignUpStepOneClient";
import ProfessionalLogin from "./component/Professional/Login/Login";
import ClientHeader from "./component/Client/Header/Header";
import ClientFooter from "./component/Client/Footer/Footer";
import ProfessionalForgot from "./component/Professional/Forgot/Forgot";
import ProfessionalHeader from "./component/Professional/Header/Header";
import ProfessionalFooter from "./component/Professional/Footer/Footer";
import Dashboard from "./component/Professional/Dashboard/Dashboard";
import Profile from "./component/Professional/Profile/Profile";
import EditProfile from "./component/Professional/EditProfile/EditProfile";
import SecurePayment from "./component/Professional/SecurePayment/SecurePayment";
import Pricing from "./component/Common/Pricing/Pricing";
import Home from "./component/Common/Home/Home";
import Job from "./component/Professional/Job/Job";
import PromotionListing from "./component/Professional/Promotion/PromotionListing";
import AddPromotion from "./component/Professional/Promotion/AddPromotion";
import ViewPromotion from "./component/Professional/Promotion/ViewPromotion/ViewPromotion";
import ClientDashboard from "./component/Client/Dashboard/Dashboard";
import Sidebar from "./component/Client/Setting/Sidebar/Sidebar";
import Setting from "./component/Client/Setting/Setting";
import SettingProfessional from "./component/Professional/Setting/Setting";
import Bids from "./component/Professional/Bids/Bids";
import Messenger from "./component/Professional/Messenger/Messenger";
import Messages from "./component/Client/Messages/Messages";
import JobDetails from "./component/Professional/JobDetails/JobDetailFullView";
import Blog from "./component/Common/Blog/Blog";
import BlogDetail from "./component/Common/BlogDetail/BlogDetail";

import Services from "./component/Common/Services/Services";
import AboutUs from "./component/Common/AboutUs/AboutUs";

import Subscription from "./component/Professional/Subscription/Subscription";
import Payment from "./component/Professional/Payment/Payment";
import HowItWork from "./component/Common/HowitWork/HowItWork";
import UpdatePromotion from "./component/Professional/Promotion/UpdatePromotion";
import { Col, Row } from "react-bootstrap";
import apple from "../src/assets/img/apple_head.png";
import robot from "../src/assets/img/Vector.png";

import ImportReviewsStepOne from "./component/Professional/Reviews/ImportReviewsStepOne";
import ImportReviewsStepTwo from "./component/Professional/Reviews/ImportReviewsStepTwo";
import GetVerified from "./component/Professional/GetVerified/GetVerified";
import ServiceAreas from "./component/Professional/ServiceAreas/ServiceAreas";
import ProfessionalNotifications from "./component/Professional/ProfessionalNotifications/ProfessionalNotifications";
import MassageNotification from "./component/Client/ClientNotification/MassageNotification";

import { GlobalStateProvider } from "./Providers/GlobalStateProvider";
import DemoDashboard from "./component/Professional/DemoDashboard/DemoDashboard";

import HowWeVetProfessional from "./component/Common/HowWeVetProfessional/HowWeVetProfessional";
import SignUpProfessional from "./component/Professional/SignUpProfessional/SignUpProfessional";
import ComingSoon from "./component/Common/ComingSoon/ComingSoon";
import ThankYou from "./component/Common/ThankYou/ThankYou";

// with header footer components
import ProfessionalFAQWeb from "./component/Common/ProfessionalFAQWeb/ProfessionalFAQWeb";
import ClientFAQWeb from "./component/Common/ClientFAQWeb/ClientFAQWeb";
import ContactUsWeb from "./component/Common/ContactUsWeb/ContactUsWeb";
import PrivacyPolicysWeb from "./component/Common/PrivacyPolicysWeb/PrivacyPolicysWeb";
import TermServiceWeb from "./component/Common/TermServiceWeb/TermServiceWeb";

// without header footer components

import ProfessionalFAQ from "./component/WithoutHeadeFooterComponents/ProfessionalFAQ/ProfessionalFAQ";
import ClientFAQ from "./component/WithoutHeadeFooterComponents/ClientFAQ/ClientFAQ";
import ContactUs from "./component/WithoutHeadeFooterComponents/ContactUs/ContactUs";
import PrivacyPolicys from "./component/WithoutHeadeFooterComponents/PrivacyPolicys/PrivacyPolicys";
import TermService from "./component/WithoutHeadeFooterComponents/TermService/TermService";

// mobile redirection componetes

import BuyProPlanFromMobileThankYou from "./component/MobileRedirectionComponents/BuyProPlanFromMobileThankYou/BuyProPlanFromMobileThankYou";
import AddServiceAreaWebFromMobile from "./component/MobileRedirectionComponents/AddServiceAreaWebFromMobile/AddServiceAreaWebFromMobile";
import AddServiceAreaWebFromMobileThankYouPage from "./component/MobileRedirectionComponents/AddServiceAreaWebFromMobileThankYouPage/AddServiceAreaWebFromMobileThankYouPage";
import AddCreditMobileThankuPage from "./component/MobileRedirectionComponents/AddCreditMobileThankuPage/AddCreditMobileThankuPage";
import BuySubscription from "./component/MobileRedirectionComponents/BuySubscription/BuySubscription";
import BuyCredits from "./component/MobileRedirectionComponents/BuyCredits/BuyCredits";
import BuyProPlanFromMobile from "./component/MobileRedirectionComponents/BuyProPlanFromMobile/BuyProPlanFromMobile";
import LoginScreen from "./component/MobileRedirectionComponents/LoginScreen/LoginScreen";
import StartedScreen from "./component/MobileRedirectionComponents/StartedScreen/StartedScreen";
import ManageDashboardScreen2 from "./component/MobileRedirectionComponents/ManageDashboardScreen2/ManageDashboardScreen2";
import ProPlanThankYou from "./component/MobileRedirectionComponents/ProPlanThankYou/ProPlanThankYou";

import BuyOfferThankYouPage from "./component/Professional/BuyOfferThankYouPage/BuyOfferThankYouPage";
import PaymentManagement from "./component/Professional/PaymentManagement/PaymentManagement";

import ServiceAreaSubTryAginPayment from "./component/MobileRedirectionComponents/ServiceAreaSubTryAginPayment/ServiceAreaSubTryAginPayment";

import ClientAppDownload from "./component/Common/ClientAppDownload/ClientAppDownload";
import ScrollToTop from "./component/Common/ScrollToTop/ScrollToTop";

function App() {
  // useEffect(() => {
  //   // Ask permission
  //   const requestPermission = async () => {
  //     const permission = await Notification.requestPermission();
  //     if (permission === "granted") {
  //       //console.log("Notification permission granted.");

  //       try {
  //         const currentToken = await getToken(getMessaging(), {
  //           vapidKey: "YOUR_VAPID_KEY", // get this from Firebase Cloud Messaging settings
  //         });

  //         if (currentToken) {
  //           //console.log("FCM Token:", currentToken);
  //           // send token to your backend to save for notifications
  //         } else {
  //           //console.log("No registration token available.");
  //         }
  //       } catch (err) {
  //         console.error("An error occurred while retrieving token.", err);
  //       }
  //     } else {
  //       //console.log("Notification permission denied.");
  //     }
  //   };

  //   requestPermission();

  //   // Listen for foreground messages
  //   onMessage(getMessaging(), (payload) => {
  //     //console.log("Message received in foreground: ", payload);
  //     // You can show a custom UI here
  //     alert(payload.notification.title + ": " + payload.notification.body);
  //   });
  // }, []);

  return (
    <>
      <GlobalStateProvider>
        <Provider store={store}>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* ✅ All routes share this layout handler */}

              {/* Pages WITHOUT Header & Footer */}
              <Route element={<LayoutWithoutHeaderFooter />}>
                <Route path="/client-faq" element={<ClientFAQ />} />
                {/* <Route path="/client-app" element={<ClientAppDownload />} /> */}
                <Route path="/privacy-policy" element={<PrivacyPolicys />} />
                <Route path="/terms-of-service" element={<TermService />} />
                <Route path="/professional-faq" element={<ProfessionalFAQ />} />
                <Route path="/contact-us" element={<ContactUs />} />
              </Route>

              <Route element={<LayoutMobileRedirection />}>
                {/* Mobile Redirection Routes */}
                <Route path="/manage-credits" element={<BuyCredits />} />
                <Route
                  path="/manage-credits/thank-you/:credits"
                  element={<AddCreditMobileThankuPage />}
                />
                <Route
                  path="/buy-pro-plan"
                  element={<BuyProPlanFromMobile />}
                />
                <Route
                  path="/offer-pro-plan/thank-you"
                  element={<BuyProPlanFromMobileThankYou />}
                />
                <Route
                  path="/pro-plan/thank-you"
                  element={<ProPlanThankYou />}
                />
                <Route
                  path="/manage-subscription"
                  element={<BuySubscription />}
                />
                <Route
                  path="/manage-service-area"
                  element={<AddServiceAreaWebFromMobile />}
                />
                <Route
                  path="/manage-service-area/thank-you"
                  element={<AddServiceAreaWebFromMobileThankYouPage />}
                />
                <Route
                  path="/manage-service-area/billing-portal-redirect/:customerId"
                  element={<ServiceAreaSubTryAginPayment />}
                />
                <Route path="/login" element={<LoginScreen />} />
                <Route path="/get-started" element={<StartedScreen />} />
                <Route
                  path="/manage-dashboard"
                  element={<ManageDashboardScreen2 />}
                />
              </Route>

              <Route element={<LayoutHandler />}>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/select-role" element={<SelectRole />} />

                <Route path="/client/login" element={<Login />} />
                <Route path="/client/signup" element={<SignUpStepOneClient />} />
                <Route
                  path="/professional/signup"
                  element={<SignUpProfessional />}
                />
                {/* <Route
                  path="/client/signup-one"
                  element={<SignUpStepOneClient />}
                /> */}
                <Route path="/client/forgot-password" element={<Forgot />} />

                <Route
                  path="/professional/forgot-password"
                  element={<ProfessionalForgot />}
                />
                <Route path="/blogs" element={<Blog />} />
                <Route path="/blog-detail/:blogId" element={<BlogDetail />} />
                <Route path="/service/:serviceName" element={<Services />} />
                <Route path="/about-us" element={<AboutUs />} />

                <Route path="/how-it-works" element={<HowItWork />} />
                <Route path="/select-role" element={<ComingSoon />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route
                  path="/how-we-vet-professionals"
                  element={<HowWeVetProfessional />}
                />
                <Route path="/pricing" element={<Pricing />} />

                <Route path="/client-faqs" element={<ClientFAQWeb />} />
                <Route
                  path="/privacy-policies"
                  element={<PrivacyPolicysWeb />}
                />
                <Route path="/terms-of-services" element={<TermServiceWeb />} />
                <Route
                  path="/professional-faqs"
                  element={<ProfessionalFAQWeb />}
                />
                <Route path="/contacts-us" element={<ContactUsWeb />} />
                <Route
                  path="/professional/payment-management"
                  element={<PaymentManagement />}
                />

                 {/* <Route
                  path="/professional/dashboard"
                  element={<DemoDashboard />}
                />  */}

                <Route
                  path="/professional/signup-one"
                  element={<SignUpStepOne />}
                />
                <Route
                  path="/professional/signup-two"
                  element={<SignUpStepTwo />}
                />
                <Route
                  path="/professional/signup-three"
                  element={<SignUpStepThree />}
                />
                <Route
                  path="/professional/signup-four"
                  element={<SignUpStepFour />}
                />
                <Route
                  path="/professional/thank-you"
                  element={<BuyOfferThankYouPage />}
                />

                {/* Auth Routes */}
                <Route path="/client/login" element={<Login />} />
                <Route
                  path="/professional/login"
                  element={<ProfessionalLogin />}
                />
                <Route
                  path="/professional/notifications"
                  element={<ProfessionalNotifications />}
                />

                {/* Professional Protected */}
                <Route element={<ProtectedRoute type="professional" />}>
                  <Route
                    path="/professional/login"
                    element={<ProfessionalLogin />}
                  />

                  <Route
                    path="/professional/dashboard"
                    element={<Dashboard />}
                  />
                  <Route path="/professional/profile" element={<Profile />} />
                  <Route
                    path="/professional/get-verified"
                    element={<GetVerified />}
                  />
                  <Route
                    path="/professional/service-areas"
                    element={<ServiceAreas />}
                  />
                  <Route
                    path="/professional/edit-profile"
                    element={<EditProfile />}
                  />
                  <Route
                    path="/professional/buy-credits"
                    element={<BuyCredits />}
                  />
                  <Route
                    path="/professional/secure-payment"
                    element={<SecurePayment />}
                  />
                  <Route
                    path="/professional/pro-plan"
                    element={<BuySubscription />}
                  />

                  <Route path="/professional/jobs" element={<Job />} />
                  <Route path="/professional/saved-jobs" element={<Job />} />
                  <Route
                    path="/professional/campaigns"
                    element={<PromotionListing />}
                  />

                  <Route
                    path="/professional/edit-campaign"
                    element={<UpdatePromotion />}
                  />
                  <Route
                    path="/professional/add-campaign"
                    element={<AddPromotion />}
                  />

                  <Route
                    path="/professional/view-campaign"
                    element={<ViewPromotion />}
                  />

                  <Route path="/professional/bids" element={<Bids />} />
                  <Route
                    path="/professional/import-reviews"
                    element={<ImportReviewsStepOne />}
                  />
                  <Route
                    path="/professional/import-reviews/step-2"
                    element={<ImportReviewsStepTwo />}
                  />

                  <Route
                    path="/professional/settings"
                    element={<SettingProfessional />}
                  />

                  <Route
                    path="/professional/messages"
                    element={<Messenger />}
                  />
                  <Route
                    path="/professional/job-details/:jobId"
                    element={<JobDetails />}
                  />
                  <Route
                    path="/professional/subscription"
                    element={<Subscription />}
                  />
                  <Route
                    path="/professional/payments/:jobId"
                    element={<Payment />}
                  />
                </Route>

                {/* Client Protected */}
                <Route element={<ProtectedRoute type="client" />}>
                  <Route
                    path="/client/dashboard"
                    element={<ClientDashboard />}
                  />
                  <Route path="/client/settings" element={<Setting />} />
                  <Route path="/client/messages" element={<Messages />} />
                  <Route
                    path="/client/notification"
                    element={<MassageNotification />}
                  />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </Provider>
      </GlobalStateProvider>
    </>
  );
}

export default App;
